import React from 'react';
import './Footer.css'
import logo from './Fruitify-removebg-preview.png'

const Footer = () => {
    return (
        <div className='footer-container'>
        {/* <div className='footer'>
            <img src={logo} alt="" />
        </div> */}
        </div>
    );
};

export default Footer;